import React from "react";

const Footer = () => {
  return (
    <footer className="fixed w-full px-[30px] lg:px-[100px] z-30 h-[100px] lg:h-[140px] flex items-center ">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <p>Design + Code by Katya Isbell </p>
      </div>
    </footer>
  );
};

export default Footer;
